import React from 'react';
import { Link } from 'react-router-dom';

import ContactIcons from '../Contact/ContactIcons';

const { PUBLIC_URL } = process.env; // set automatically from package.json:homepage

const SideBar = () => (
  <section id="sidebar">
    <section id="intro">
      <Link to="/" className="logo">
        <img src={`${PUBLIC_URL}/images/me.jpg`} alt="" />
      </Link>
      <header>
        <h2>Aditya Kumar Iyer</h2>
        <p><a href="mailto:aditya.kumar.iyer@gmail.com">aditya.kumar.iyer@gmail.com</a></p>
      </header>
    </section>

    <section className="blurb">
      <h2>About</h2>
      <p>Hi, I&apos;m Aditya. I&apos;m a backend software developer.
        I am an <a href="https://www.cse.iitd.ac.in/">IIT Delhi CSE</a> graduate.
      </p>
      <ul className="actions">
        <li>
          {!window.location.pathname.includes('/resume') ? <Link to="/resume" className="button">Learn More</Link> : <Link to="/about" className="button">About Me</Link>}
        </li>
      </ul>
    </section>

    <section id="footer">
      <ContactIcons />
      <p className="copyright">&copy; Aditya Kumar Iyer <Link to="/">adityaiyer.in</Link>.</p>
    </section>
  </section>
);

export default SideBar;
